import { useEffect, useState } from 'react';

import { type OptionType } from '@atlaskit/select';

import { useRoutingRuleModalService } from '../../services/routing-rule-modal';

export const useRoutingRuleModalController = () => {
	const { getTimezones, isTimezonesLoading } = useRoutingRuleModalService();

	const [timezones, setTimezones] = useState<OptionType[]>();

	useEffect(() => {
		getTimezones().then((res) => {
			if (res.timezones) {
				const options = res.timezones.map((timezone) => ({
					label: timezone.simpleName,
					value: timezone.id,
				}));

				setTimezones(options);
			}
		});
	}, [getTimezones]);

	return {
		timezones,

		isTimezonesLoading,
	};
};
